import React from 'react';

import {
  createStyles,
  Divider,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Theme,
  WithStyles,
  withStyles,
} from '@material-ui/core';
import MuiExpansionPanel, { ExpansionPanelProps as MuiExpansionPanelProps } from '@material-ui/core/ExpansionPanel';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import classnames from 'classnames';

const styles = (theme: Theme) =>
  createStyles({
    root: {},
    panelRoot: {
      position: 'inherit',
    },
    panelRootOutlined: {
      border: `1px solid ${theme.palette.divider}`,
      position: 'initial',
      borderRadius: 4,
    },
    panelExpanded: {
      margin: 0,
    },
    panelSummaryRoot: {
      minHeight: '0 !important',
      padding: `0 ${theme.spacing.unit * 2}px`,
    },
    panelSummaryContent: {
      margin: `${theme.spacing.unit}px 0 !important`,
    },
    panelSummaryExpandIcon: {
      right: theme.spacing.unit / 2,
      color: theme.palette.primary.main,
    },
    panelDetails: {
      padding: `${theme.spacing.unit}px 0`,
    },
  });

export interface ExpansionPanelProps
  extends Omit<MuiExpansionPanelProps, 'classes' | 'title'>,
    WithStyles<typeof styles> {
  variant?: 'outlined';
  summary: React.ReactNode;
}

const ExpansionPanel: React.FC<ExpansionPanelProps> = ({ classes, variant, summary, children, ...rest }) => (
  <MuiExpansionPanel
    classes={{
      root: classnames(classes.panelRoot, { [classes.panelRootOutlined]: variant === 'outlined' }),
      expanded: classes.panelExpanded,
    }}
    elevation={0}
    {...rest}
  >
    <ExpansionPanelSummary
      classes={{
        root: classes.panelSummaryRoot,
        content: classes.panelSummaryContent,
        expandIcon: classes.panelSummaryExpandIcon,
      }}
      expandIcon={<ExpandMoreIcon />}
    >
      {summary}
    </ExpansionPanelSummary>
    <Divider />
    <ExpansionPanelDetails className={classes.panelDetails}>{children}</ExpansionPanelDetails>
  </MuiExpansionPanel>
);

export default withStyles(styles, { name: 'LumaExpansionPanel' })(ExpansionPanel);
